import { useCallback, useEffect, useMemo, useState, memo } from 'react'
import { useDispatch } from 'react-redux'
import { doUpsertAiConversationSuggestion } from 'ducks/ai/operations'
import { dumbLinkify } from 'util/strings'
import { Loader } from 'shared/ui'

import SanitizedHTML from 'shared/components/ui/SanitizedHTML'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'

import { styles as baseStyles } from '../styles'
import { styles } from './styles'

const MAX_CHARACTERS = 200

const Summary = ({ ticketId, suggestion, isLoading }) => {
  const dispatch = useDispatch()
  const [isShowMore, setShowMore] = useState(false)

  useEffect(
    () => {
      if (suggestion?.value?.length <= MAX_CHARACTERS) {
        setShowMore(true)
      }
    },
    [suggestion]
  )

  const onClick = useCallback(
    () => {
      dispatch(
        doUpsertAiConversationSuggestion({
          suggestionType: 'summary',
          suggestionId: suggestion.id,
          ticketId,
        })
      )
    },
    [dispatch, ticketId, suggestion]
  )

  const onShowMoreClick = useCallback(() => setShowMore(true), [])

  const textValue = useMemo(
    () => {
      if (isShowMore) {
        return suggestion.value
      }

      if (suggestion.value && suggestion.value.length > MAX_CHARACTERS) {
        return suggestion.value.substring(0, MAX_CHARACTERS).concat('...')
      }

      return suggestion.value
    },
    [isShowMore, suggestion]
  )

  if (!suggestion.id) {
    return (
      <div className="grui flex flex-col">
        <span css={baseStyles.actionTitle}>Summarize the conversation</span>

        {isLoading ? (
          <Loader className="grui my-7" />
        ) : (
          <Button
            className="grui mt-5 mr-auto px-6"
            type="tertiary"
            size="small"
            onClick={onClick}
            css={baseStyles.actionButton}
          >
            Summarize
          </Button>
        )}
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="grui flex flex-col">
        <span css={baseStyles.actionTitle}>Summary</span>

        <Loader className="grui my-7" />
      </div>
    )
  }

  return (
    <div className="grui flex flex-col">
      <span css={baseStyles.actionTitle}>Summary</span>

      <SanitizedHTML
        css={!isShowMore && styles.text}
        className="body"
        html={dumbLinkify(textValue, { showFullUrl: true })}
      />

      {!isShowMore && (
        <a
          css={styles.showMore}
          className="grui w-full flex justify-end mt-4"
          onClick={onShowMoreClick}
          rel="noopener noreferrer"
        >
          + Show more
        </a>
      )}
    </div>
  )
}

export default memo(Summary)
